import { useCallback, useRef } from "react";
import { useMutation } from "@tanstack/react-query";
import { PortalAppointmentService } from "../../services/portal/PortalAppointmentService";
import { useInvalidatePortalAppointments } from "./usePortalQueries";
import { generateIdempotencyKey } from "../../utils/idempotencyKey";
function useIdempotencyKey() {
    const keyRef = useRef(generateIdempotencyKey());
    const reset = useCallback(() => {
        keyRef.current = generateIdempotencyKey();
    }, []);
    return { current: () => keyRef.current, reset };
}
export function useCancelAppointmentMutation() {
    const invalidate = useInvalidatePortalAppointments();
    const key = useIdempotencyKey();
    const mutation = useMutation({
        mutationFn: (vars) => PortalAppointmentService.cancel({
            ...vars,
            idempotencyKey: key.current(),
        }),
        onSuccess: invalidate,
    });
    return { ...mutation, beginAttempt: key.reset };
}
export function useSelfAttestMutation() {
    const invalidate = useInvalidatePortalAppointments();
    const key = useIdempotencyKey();
    const mutation = useMutation({
        mutationFn: (vars) => PortalAppointmentService.selfAttest({
            ...vars,
            idempotencyKey: key.current(),
        }),
        onSuccess: invalidate,
    });
    return { ...mutation, beginAttempt: key.reset };
}
export function useRescheduleAppointmentMutation() {
    const invalidate = useInvalidatePortalAppointments();
    const key = useIdempotencyKey();
    const mutation = useMutation({
        mutationFn: (vars) => PortalAppointmentService.reschedule({
            ...vars,
            idempotencyKey: key.current(),
        }),
        onSuccess: invalidate,
    });
    return { ...mutation, beginAttempt: key.reset };
}
